import { render, staticRenderFns } from "./KarmaCategoryViewInfo.vue?vue&type=template&id=397685e5&"
import script from "./KarmaCategoryViewInfo.vue?vue&type=script&lang=js&"
export * from "./KarmaCategoryViewInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports